import { mobileNavIsActiveClass, searchIsActiveClass, delayLoadClass as pageLoaderClass } from "../constants";
import ReactiveClassStore from "./ReactiveClassStore";

const body = /** @type {HTMLElement} */ (document.querySelector('body'));

export const isMobileActive = new ReactiveClassStore(body, mobileNavIsActiveClass);
export const isSearchActive = new ReactiveClassStore(body, searchIsActiveClass);
export const isPageLoading = new ReactiveClassStore(body, pageLoaderClass);
